import { defineMessages } from 'react-intl';

export default defineMessages({
    quote: {
        id: 'integration.quoteandbind.directives.templates.qnb-info-bar.Homeowners Insurance Quote',
        defaultMessage: 'Quote'
    },
    location: {
        id: 'integration.quoteandbind.directives.templates.qnb-info-bar.Location',
        defaultMessage: 'Location'
    },
    account: {
            id: 'integration.quoteandbind.directives.templates.qnb-info-bar.Account',
            defaultMessage: 'Account'
    } 
});
